import { Button } from '@shared/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface ProfessionalsPaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function ProfessionalsPagination({
  currentPage,
  totalPages,
  onPageChange
}: ProfessionalsPaginationProps) {
  if (totalPages <= 1) {
    return null
  }

  const pages = []

  for (let i = 0; i < totalPages; i++) {
    const pageNum = i + 1

    // Show first page, last page, current page and adjacent pages
    if (
      pageNum === 1 ||
      pageNum === totalPages ||
      (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
    ) {
      pages.push(
        <Button
          key={pageNum}
          variant={pageNum === currentPage ? 'default' : 'outline'}
          size="sm"
          className="w-10"
          onClick={() => onPageChange(pageNum)}
        >
          {pageNum}
        </Button>
      )
    } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
      // Show ellipsis for gaps
      pages.push(
        <span key={`ellipsis-${pageNum}`} className="px-2">
          ...
        </span>
      )
    }
  }

  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft className="h-4 w-4" />
        Anterior
      </Button>

      <div className="flex items-center gap-1">{pages}</div>

      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Siguiente
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
